import React, { useState } from 'react';
import { api } from '../utils/api';

export default function LoginPage({ onLogin, notice }) {
  const [loginId, setLoginId] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      const { token, user } = await api.login(loginId, password);
      onLogin(token, user);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={styles.bg}>
      <div style={styles.card} className="fade-in">
        <div style={styles.header}>
          <div style={styles.rule} />
          <h1 style={styles.title}>催事営業 KPIシステム</h1>
          <p style={styles.sub}>ログインしてください</p>
        </div>

        {notice && (
          <div style={{ ...styles.error, background: 'var(--hold-bg)', color: 'var(--hold)', border: '1px solid #5C4718', marginBottom: 16 }}>
            {notice}
          </div>
        )}

        <form onSubmit={handleSubmit} style={styles.form}>
          <div style={styles.field}>
            <label style={styles.label}>ログインID</label>
            <input
              style={styles.input}
              type="text"
              value={loginId}
              onChange={e => setLoginId(e.target.value)}
              placeholder="ログインIDを入力"
              required
              autoFocus
              autoCapitalize="none"
              autoCorrect="off"
              spellCheck={false}
              autoComplete="username"
            />
          </div>
          <div style={styles.field}>
            <label style={styles.label}>パスワード</label>
            <input
              style={styles.input}
              type="password"
              value={password}
              onChange={e => setPassword(e.target.value)}
              placeholder="パスワードを入力"
              required
              autoComplete="current-password"
            />
          </div>

          {error && <div style={styles.error}>{error}</div>}

          <button
            type="submit"
            style={{ ...styles.btn, opacity: loading ? 0.7 : 1 }}
            disabled={loading}
          >
            {loading ? 'ログイン中...' : 'ログイン'}
          </button>
        </form>
      </div>
    </div>
  );
}

const styles = {
  bg: {
    // ドキュメントをスクロールさせない設計（index.css）なので、この画面自身をスクロール領域にする。
    // キーボードが出て縦が足りなくなっても入力欄に届く。
    height: '100%',
    overflowY: 'auto',
    background: 'var(--paper)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: 'var(--s6)',
  },
  card: {
    background: 'var(--field)',
    border: '1px solid var(--rule)',
    borderRadius: 'var(--r-sm)',
    padding: 'var(--s8)',
    width: '100%',
    maxWidth: 380,
  },
  header: { marginBottom: 'var(--s8)' },
  // 見出しの左に藍の縦罫を置く。サイドバーのロゴと同じ印で、装飾ではなく目印。
  rule: { width: 3, height: 20, background: 'var(--grad-primary)', borderRadius: 2, marginBottom: 'var(--s3)' },
  title: { fontSize: 'var(--t-head)', fontWeight: 700, color: 'var(--ink)', marginBottom: 'var(--s1)' },
  sub: { color: 'var(--ink-mute)', fontSize: 'var(--t-body)' },
  form: { display: 'flex', flexDirection: 'column', gap: 'var(--s4)' },
  field: { display: 'flex', flexDirection: 'column', gap: 'var(--s1)' },
  label: { fontSize: 'var(--t-note)', fontWeight: 600, color: 'var(--ink-soft)' },
  input: {
    minHeight: 48,
    padding: '0 var(--s3)',
    borderRadius: 'var(--r-sm)',
    border: '1px solid var(--rule-strong)',
    fontSize: 'var(--t-lead)',
    outline: 'none',
    transition: 'border-color 120ms, box-shadow 120ms',
    background: 'var(--field)',
    color: 'var(--ink)',
    colorScheme: 'dark',
  },
  error: {
    background: 'var(--loss-bg)',
    color: 'var(--loss)',
    padding: 'var(--s3) var(--s4)',
    borderRadius: 'var(--r-sm)',
    fontSize: 'var(--t-body)',
    border: '1px solid #6B3A36',
  },
  btn: {
    background: 'var(--grad-primary)',
    color: '#fff',
    border: '1px solid var(--mark)',
    borderRadius: 'var(--r-sm)',
    minHeight: 48,
    fontSize: 'var(--t-lead)',
    fontWeight: 600,
    marginTop: 'var(--s1)',
    cursor: 'pointer',
  },
};
